module.exports = __webpack_public_path__ + "static/img/7.66a8c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/7.png
// module id = d7Vh
// module chunks = 0